// src/config.js
export const stripePublishKey = 'pk_live_51Q8QCXI7g6jAMftIUJQPY4cUUidHMywgM6e2PRpWWa2Pqp6TTaN3NKXO8ibvWNq852Lllfl4IOkT3ZX0zfTzWJ8e00ZiqqOuvT';